<template>
  <v-row>
    <v-col cols="12">
      <div v-for="(value, key) in fileFormatter" :key="key" class="key-value-item">
        <div class="key">{{ key }}:</div>
        <div class="value">
          <span v-if="Array.isArray(value)">
            [{{
                 value.join(", ")
            }}]
          </span>
          <span v-else>{{ value }}</span>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Index from "../Index.vue";
import Buttons from "../component/Buttons.vue";
import Pagination from "../component/Pagination.vue";

import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Index, Buttons, Pagination },
  name: "PanelistReport",
  data: () => ({
    fileFormatter: {},
    options: {},
    sort: "",
    importFile: null,
    editReportMode: false,
    fromDateMenu: false,
    fromDateVal: null,
    isLoading: false,
    fullPage: true,
    allSelected: false,
    perpage: 10,
    dasboardListingData: [],
    selectedRetrievalRecords: [],
    totRecords: "",
    totPage: "",
    currentPage: 1,
    lastPage: "",
  }),
  async mounted() {
    this.getFieldHeading();
  },

  methods: {
    getFieldHeading() {
      let view = this;
      let dasboardListingUrl = view.$url("ADD_DASHBOARD_LISTING_FIELDS");
      try {
        this.$emit('loaderValue',true)
        this.$fetch({ requiresAuth: true, operation: "view", vueScope: view })
          .get(dasboardListingUrl)
          .then((res) => {
            console.log(res.data.payload);
            view.fileFormatter = res.data.payload;
            this.$emit('loaderValue',false)
            
          })
          .catch((error) => {
            this.$emit('loaderValue',false)
            this.$swal.fire({
              icon: "success",
              title: "Error",
              text: error,
            });
          });
      } catch (e) {
        this.$emit('loaderValue',false)
        console.log("error", e);
      }
    },
  },
};
</script>

<style scoped>
.payload-display {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  margin-bottom: 20px;
  color: #333;
}

.key-value-pairs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
}

.key-value-item {
  display: flex;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.key {
  font-weight: bold;
  min-width: 200px;
  color: #2c3e50;
}

.value {
  color: #42b983;
  flex: 1;
}

.array-length {
  font-size: 0.8em;
  color: #666;
  margin-top: 2px;
}
</style> 